import React from 'react';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { ServiceCard } from '../components/ServiceCard';
import { WhoWeServe } from '../components/WhoWeServe';
import { ExpandedServices } from '../components/ExpandedServices';
import { HowItWorks } from '../components/HowItWorks';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { GraphicDesignSection } from '../components/GraphicDesignSection';
import { LocalSEO } from '../components/LocalSEO';
import { CTASection } from '../components/CTASection';
import { Printer, Shirt, Palette, Film, Flame, Zap, Sparkles, Package } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function Home() {
  const coreServices = [{
    title: 'Screen Printing',
    description: 'High-volume custom screen printing for t-shirts, hoodies, and apparel. Perfect for teams, events, and businesses in LaGrange and Northeast Indiana.',
    icon: <Printer data-id="element-357" />,
    accentColor: 'yellow' as const
  }, {
    title: 'Embroidery',
    description: 'Professional embroidery services adding a premium touch to polos, hats, jackets, and corporate wear. Custom embroidery near you.',
    icon: <Shirt data-id="element-358" />,
    accentColor: 'teal' as const
  }, {
    title: 'Direct To Garment',
    description: 'Full-color DTG printing ideal for complex designs and smaller batches with soft-hand feel. No minimums required.',
    icon: <Palette data-id="element-359" />,
    accentColor: 'pink' as const
  }, {
    title: 'Direct To Film',
    description: 'Advanced DTF printing technology for vibrant, durable designs on any fabric type. Perfect for detailed artwork.',
    icon: <Film data-id="element-360" />,
    accentColor: 'yellow' as const
  }, {
    title: 'Laser Engraving & Etching',
    description: 'Precision laser engraving services for unique, tone-on-tone branding on fleece, leather, and technical fabrics.',
    icon: <Zap data-id="element-361" />,
    accentColor: 'teal' as const
  }, {
    title: 'Heat Transfers',
    description: 'Custom heat transfer printing for names, numbers, and designs. Ideal for sports teams and personalized apparel.',
    icon: <Flame data-id="element-362" />,
    accentColor: 'pink' as const
  }, {
    title: 'Graphic Design',
    description: 'Professional graphic design services to create or refine your artwork. We convert ideas to print-ready vector art.',
    icon: <Sparkles data-id="element-363" />,
    accentColor: 'yellow' as const
  }, {
    title: 'Personalized Products',
    description: 'Custom personalized gifts and products for any occasion. From single items to bulk orders.',
    icon: <Package data-id="element-364" />,
    accentColor: 'teal' as const
  }];
  return <div className="flex flex-col w-full" data-id="element-365">
      {/* 1. Hero Section */}
      <Hero data-id="element-366" />

      {/* 2. Trust/Authority Strip */}
      <TrustStrip data-id="element-367" />

      {/* 3. Core Services Overview */}
      <section className="py-24 bg-white" data-id="element-368">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-369">
          <div className="text-center mb-16" data-id="element-370">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-371">
              Our Core Services
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-372">
              From screen printing to laser engraving, we offer a complete range
              of customization services to bring your vision to life.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-373">
            {coreServices.map((service, index) => <ServiceCard key={index} {...service} data-id="element-374" />)}
          </div>

          <div className="text-center" data-id="element-375">
            <Button variant="outline" size="lg" data-id="element-376">
              View All Services & Pricing
            </Button>
          </div>
        </div>
      </section>

      {/* 4. Who We Serve */}
      <WhoWeServe data-id="element-377" />

      {/* 5. Expanded Services */}
      <ExpandedServices data-id="element-378" />

      {/* 6. How It Works */}
      <HowItWorks data-id="element-379" />

      {/* 7. Featured Products/Shop */}
      <FeaturedProducts data-id="element-380" />

      {/* 8. Graphic Design Support */}
      <GraphicDesignSection data-id="element-381" />

      {/* 9. Local SEO Section */}
      <LocalSEO data-id="element-382" />

      {/* 10. Final Conversion CTA */}
      <CTASection data-id="element-383" />
    </div>;
}